import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Textarea from "@amzn/meridian/textarea";
import React, {useCallback} from "react";
import Button from "@amzn/meridian/button";
import {FormattedMessage} from "react-intl";
import {BATCH_SIZE, COMMA_REGEX, EMPTY_SPACE, NEW_LINE_REGEX} from "../constants/Constants";
import PrintLabelContextProvider from "./context/PrintLabelContext";
import {PrintLabelSheetDialog} from "./PrintLabelSheetDialog";

export const LabelSheet = (props) => {
    const [input, setInput] = React.useState("");
    const [trackingIds, setTrackingIds] = React.useState([]);
    const [isValid, setIsValid] = React.useState(true);
    const [openCASDialog, setOpenCASDialog] = React.useState(false);
    const onClickCASButton = useCallback(() => setOpenCASDialog(true), []);

    const updateTrackingIds = (input) => {
        setInput(input)
        setTrackingIds(splitInput(input));
        if(trackingIds.length > BATCH_SIZE) {
            setIsValid(false);
        } else {
            setIsValid(true);
        }
    }

    const submitTrackingIds = () => {
        if(isValid) {
            onClickCASButton();
        }
    }

    return (
        <PrintLabelContextProvider>
            <Row widths="grid-10" spacingInset="medium large">
                <Box type="fill" backgroundColor="secondary" spacingInset="none">
                    <div style={{overflowX: "scroll", maxWidth: "100%"}}>
                        <Row widths="grid-2" spacingInset="medium large" alignmentVertical="top">
                            <Column>
                                <Text type="h100">Batch Package Id</Text>
                                <Textarea rows={4} placeholder="Enter Tracking Ids" onChange={updateTrackingIds} value={input}/>
                                <Text type="b200" color="secondary"> {trackingIds.length} Packages</Text>
                            </Column>
                        </Row>
                        <Row spacingInset="medium large" alignmentVertical="top">
                            {!isValid && <Text type="h100" color="error"> TrackingIds cannot be more than {BATCH_SIZE} </Text>}
                        </Row>
                    </div>
                    <Row spacingInset="medium large" alignmentHorizontal="left" alignmentVertical="top">
                        <Button type="tertiary" onClick={submitTrackingIds} value={trackingIds}
                                disabled={trackingIds.length === 0 || !isValid} >
                            <FormattedMessage id="print.label_sheet" defaultMessage="Get Label Sheet"/>
                        </Button>
                    </Row>
                    {openCASDialog &&
                    <PrintLabelSheetDialog isModalOpen={openCASDialog} onModelOpenChange={setOpenCASDialog} trackingIds={trackingIds}/>}
                </Box>
            </Row>
        </PrintLabelContextProvider>)
}


const splitInput = (input) => {
    if (!input) {
        return [];
    }
    // replace all comma and new line characters with empty space
    return input
        .replace(NEW_LINE_REGEX, EMPTY_SPACE)
        .replace(COMMA_REGEX, EMPTY_SPACE)
        .split(EMPTY_SPACE)
        .filter(id => !!id)
        .map(id => id.trim());
}


// WEBPACK FOOTER //
// ./src/components/labelSheet/LabelSheet.js